const { useSelector } = require("react-redux");
import LoaderData from "../Ui/Loader";

const HandleLoading = () => {
    const appLoading = useSelector((state) => state.app.appLoading);

    return (
        <LoaderData size={"big"} showLoad={appLoading} fixed={true} />
    )
}

export default HandleLoading;